import { render } from "./stock-running-out.svg?vue&type=template&id=e79dbdec"
const script = {}
script.render = render

export default script